import { createContext, useState } from "react";
export const livetrackingcontext = createContext();
export default function LiveTrackingContenxt({ children }) {
	const [vehicleArchived, setVehicleArchived] = useState("All vehicles");
	const [trackingType, setTrackingType] = useState("vehicle");
	const [trackingTypeIds, setTrackingTypeIds] = useState([]);
	const [multipleSelect, setMultipleSelect] = useState(false);
	const [vehiclesIds, setVehicleIds] = useState([]);
	const [shownData, setShownData] = useState([]);
	const [selectedId, setSelectedId] = useState();
	const [imei, setImei] = useState(null);
	const [alerts, setAlerts] = useState(false);

	return (
		<>
			<livetrackingcontext.Provider
				value={{
					vehicleArchived,
					setVehicleArchived,
					trackingType,
					setTrackingType,
					trackingTypeIds,
					setTrackingTypeIds,
					multipleSelect,
					setMultipleSelect,
					vehiclesIds,
					setVehicleIds,
					shownData,
					setShownData,
					selectedId,
					setSelectedId,
					imei,
					setImei,
					alerts,
					setAlerts,
				}}
			>
				{children}
			</livetrackingcontext.Provider>
		</>
	);
}
